module.exports = __webpack_public_path__ + "img/logo.49c05b95.svg";